var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "eventList", attrs: { id: "eventList" } }, [
    _vm.events.length
      ? _c(
          "div",
          _vm._l(_vm.events, function(event, index) {
            return _c(
              "div",
              {
                key: event.id,
                on: {
                  click: function($event) {
                    return _vm.showEvent(event)
                  }
                }
              },
              [
                _c("div", { staticClass: "eventHeader" }, [
                  _vm.isEventNowOrRecent(event) &&
                  (index == 0 ||
                    !_vm.isEventNowOrRecent(_vm.events[Math.max(0, index - 1)]))
                    ? _c("div", [_c("div", [_vm._v("RECENT")])])
                    : _vm.isEventUpcoming(event) &&
                      (index == 0 ||
                        !_vm.isEventUpcoming(
                          _vm.events[Math.max(0, index - 1)]
                        ))
                    ? _c("div", [_c("div", [_vm._v("UPCOMING")])])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "event" }, [
                  _c("div", { staticClass: "cardContainer" }, [
                    event.mediaItems && event.mediaItems.length > 0
                      ? _c("div", { staticClass: "cardMediaBackground" }, [
                          event.mediaItems[0].thumbnailLink
                            ? _c("div", [
                                _c("img", {
                                  staticClass: "cardMedia",
                                  attrs: {
                                    src: event.mediaItems[0].thumbnailLink
                                  }
                                })
                              ])
                            : _c("div", [
                                _c("img", {
                                  staticClass: "cardMedia",
                                  attrs: { src: event.mediaItems[0].link }
                                })
                              ])
                        ])
                      : _c(
                          "div",
                          { staticClass: "cardMediaBackground_placeholder" },
                          [
                            _c("img", {
                              staticClass: "cardMedia_placeholder",
                              attrs: {
                                src: require("../assets/images/LogoCardPlaceholder.png")
                              }
                            })
                          ]
                        ),
                    _vm._v(" "),
                    _c("div", { staticClass: "cardBottomBackground" }),
                    _vm._v(" "),
                    _vm.isEventChangedForUserInvitation(event, _vm.appUser)
                      ? _c("div", { staticClass: "col0" }, [
                          _c("div", { staticClass: "statusDot" })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col1" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(event.name))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dateTime" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formattedDateTimeString(
                              event.dateTime.toDate(),
                              event.location,
                              _vm.appUser.timeZoneIdentifier
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      event.location
                        ? _c("div", { staticClass: "location" }, [
                            _vm._v(
                              _vm._s(event.location.name) +
                                " (" +
                                _vm._s(event.location.cityState) +
                                ")  "
                            ),
                            event.weatherForecast
                              ? _c(
                                  "span",
                                  { staticClass: "material-symbols-outlined" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.googleWeatherSymbolForSfSymbol(
                                          event.weatherForecast
                                            .forecastSymbolName
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col2" }, [
                      _c("p", [
                        _vm.invitationForAppUser(event, _vm.appUser)
                          .attendanceStatus == 0
                          ? _c("img", {
                              staticClass: "colorizeAttendanceStatusUnknown",
                              attrs: {
                                src: require("../assets/images/AttendanceStatusIcon_Unknown.png"),
                                width: "44",
                                height: "44"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.invitationForAppUser(event, _vm.appUser)
                          .attendanceStatus == 1
                          ? _c("img", {
                              staticClass: "colorizeAttendanceStatusAttending",
                              attrs: {
                                src: require("../assets/images/AttendanceStatusIcon_In.png"),
                                width: "44",
                                height: "44"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.invitationForAppUser(event, _vm.appUser)
                          .attendanceStatus == 2
                          ? _c("img", {
                              staticClass: "colorizeAttendanceStatusAttending",
                              attrs: {
                                src: require("../assets/images/AttendanceStatusIcon_InPlusOne.png"),
                                width: "44",
                                height: "44"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.invitationForAppUser(event, _vm.appUser)
                          .attendanceStatus == 3
                          ? _c("img", {
                              staticClass:
                                "colorizeAttendanceStatusNotAttending",
                              attrs: {
                                src: require("../assets/images/AttendanceStatusIcon_Out.png"),
                                width: "44",
                                height: "44"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.invitationForAppUser(event, _vm.appUser)
                          .attendanceStatus == 4
                          ? _c("img", {
                              staticClass: "colorizeAttendanceStatusUndecided",
                              attrs: {
                                src: require("../assets/images/AttendanceStatusIcon_Undecided.png"),
                                width: "44",
                                height: "44"
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { margin: "0.5em 0 0.5em 0" } },
                        [
                          _c("span", { staticClass: "attendanceCountIn" }, [
                            _c("img", {
                              staticClass: "colorizeAttendanceStatusAttending",
                              attrs: {
                                src: require("../assets/images/AttendanceStatusIcon_In.png"),
                                width: "16",
                                height: "16"
                              }
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.eventInvitationAttendanceCount(event, 1) +
                                    _vm.eventInvitationAttendanceCount(
                                      event,
                                      2
                                    ) *
                                      2
                                )
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "attendanceCountOut" }, [
                            _c("img", {
                              staticClass:
                                "colorizeAttendanceStatusNotAttending",
                              attrs: {
                                src: require("../assets/images/AttendanceStatusIcon_Out.png"),
                                width: "16",
                                height: "16"
                              }
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.eventInvitationAttendanceCount(event, 3)
                                )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "attendanceCountUndecided" },
                            [
                              _c("img", {
                                staticClass:
                                  "colorizeAttendanceStatusUndecided",
                                attrs: {
                                  src: require("../assets/images/AttendanceStatusIcon_Undecided.png"),
                                  width: "16",
                                  height: "16"
                                }
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.eventInvitationAttendanceCount(
                                      event,
                                      0
                                    ) +
                                      _vm.eventInvitationAttendanceCount(
                                        event,
                                        4
                                      )
                                  )
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.eventCalloutText(event, true) ||
                    (event.mediaItems && event.mediaItems.length > 1) ||
                    (event.messages && event.messages.length > 0)
                      ? _c(
                          "div",
                          { class: _vm.eventCalloutContainerStyle(event) },
                          [
                            _c("div", { staticClass: "callout" }, [
                              _vm.eventCalloutText(event, true)
                                ? _c(
                                    "span",
                                    { staticClass: "calloutFragment" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .eventCalloutText(event, true)
                                            .toUpperCase()
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.eventCalloutText(event, true) &&
                              ((event.mediaItems &&
                                event.mediaItems.length > 1) ||
                                (event.messages && event.messages.length > 0))
                                ? _c("span", { staticClass: "calloutDivider" })
                                : _vm._e(),
                              _vm._v(" "),
                              event.mediaItems && event.mediaItems.length > 1
                                ? _c(
                                    "span",
                                    { staticClass: "calloutFragment" },
                                    [
                                      _c("img", {
                                        staticClass: "colorizeBackground",
                                        attrs: {
                                          src: require("../assets/images/CalloutIcon_Multimedia.png"),
                                          height: "16"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              event.messages && event.messages.length > 0
                                ? _c(
                                    "span",
                                    { staticClass: "calloutFragment" },
                                    [
                                      _c("img", {
                                        staticClass: "colorizeBackground",
                                        attrs: {
                                          src: require("../assets/images/CalloutIcon_Messages.png"),
                                          height: "16"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ]
            )
          }),
          0
        )
      : _c("div", [
          _c("p", { staticClass: "emptyList" }, [_vm._v("No upcoming events")])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9aac7350", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9aac7350","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EventList.vue
// module id = null
// module chunks = 